import { CardClickPopupType } from '@colonist/game-card-types';
import { CardEnum, CardTypeEnum, TurnState } from '@colonist/game-states';
export function getProgressCardDataPolitics() {
    return [
        {
            cardEnum: CardEnum.ProgressCardPoliticsBack,
            cardTypeEnum: CardTypeEnum.ProgressPolitics,
            isCardBack: true,
            clickPopupType: CardClickPopupType.None,
            allowableTurnStates: undefined
        },
        {
            cardEnum: CardEnum.ProgressCardPoliticsBishop,
            cardTypeEnum: CardTypeEnum.ProgressPolitics,
            isCardBack: false,
            clickPopupType: CardClickPopupType.ConfirmationPopup,
            allowableTurnStates: [
                TurnState.Turn
            ]
        },
        {
            cardEnum: CardEnum.ProgressCardPoliticsConstitution,
            cardTypeEnum: CardTypeEnum.ProgressPolitics,
            isCardBack: false,
            clickPopupType: CardClickPopupType.ConfirmationPopup,
            allowableTurnStates: [
                TurnState.Turn
            ]
        },
        {
            cardEnum: CardEnum.ProgressCardPoliticsDeserter,
            cardTypeEnum: CardTypeEnum.ProgressPolitics,
            isCardBack: false,
            clickPopupType: CardClickPopupType.NormalClick,
            allowableTurnStates: [
                TurnState.Turn
            ]
        },
        {
            cardEnum: CardEnum.ProgressCardPoliticsDiplomat,
            cardTypeEnum: CardTypeEnum.ProgressPolitics,
            isCardBack: false,
            clickPopupType: CardClickPopupType.ConfirmationPopup,
            allowableTurnStates: [
                TurnState.Turn
            ]
        },
        {
            cardEnum: CardEnum.ProgressCardPoliticsIntrigue,
            cardTypeEnum: CardTypeEnum.ProgressPolitics,
            isCardBack: false,
            clickPopupType: CardClickPopupType.ConfirmationPopup,
            allowableTurnStates: [
                TurnState.Turn
            ]
        },
        {
            cardEnum: CardEnum.ProgressCardPoliticsSaboteur,
            cardTypeEnum: CardTypeEnum.ProgressPolitics,
            isCardBack: false,
            clickPopupType: CardClickPopupType.ConfirmationPopup,
            allowableTurnStates: [
                TurnState.Turn
            ]
        },
        {
            cardEnum: CardEnum.ProgressCardPoliticsSpy,
            cardTypeEnum: CardTypeEnum.ProgressPolitics,
            isCardBack: false,
            clickPopupType: CardClickPopupType.ConfirmationPopup,
            allowableTurnStates: [
                TurnState.Turn
            ]
        },
        {
            cardEnum: CardEnum.ProgressCardPoliticsWarlord,
            cardTypeEnum: CardTypeEnum.ProgressPolitics,
            isCardBack: false,
            clickPopupType: CardClickPopupType.ConfirmationPopup,
            allowableTurnStates: [
                TurnState.Turn
            ]
        },
        {
            cardEnum: CardEnum.ProgressCardPoliticsWedding,
            cardTypeEnum: CardTypeEnum.ProgressPolitics,
            isCardBack: false,
            clickPopupType: CardClickPopupType.ConfirmationPopup,
            allowableTurnStates: [
                TurnState.Turn
            ]
        }
    ];
}
